import { Alert, Collapse } from '@mui/material'
import { PreviewRender } from './PreviewRender'

export const PfpPreview = ({ calculateRenderHashes, isIllegalCombination }) => {
    return (
        <div className="my-auto">
            <Collapse in={true}>
                <div className="text-center text-xl py-10">Preview</div>
                <PreviewRender
                    calculateRenderHashes={calculateRenderHashes}
                    isIllegalCombination={isIllegalCombination}
                />
                <Alert
                    className="w-96"
                    severity={
                        isIllegalCombination() !== null ? 'error' : 'success'
                    }
                >
                    {isIllegalCombination() !== null
                        ? isIllegalCombination()
                        : 'This combination of attributes is valid according to the rules defined'}
                </Alert>
            </Collapse>
        </div>
    )
}
